import { type FunctionComponent, type ReactNode, useEffect, useState } from "react";

import { useArticleSpeechContext } from "~/components/article/article-speech/contexts";

import Pippa from "./img-pippa.png";
import {
  Container,
  Description,
  PippaImage,
  StyledButton,
  StyledLineImg,
  StyledPlayIcon,
  TextContainer,
  Title,
} from "./styles";

type Props = {
  children?: (isClicked: boolean) => ReactNode;
  className?: string;
};

export const ListenNow: FunctionComponent<Props> = ({ children, className }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isPlayed, setIsPlayed] = useState(false);
  const { articleSpeechifyPlayer } = useArticleSpeechContext();

  useEffect(() => {
    if (!articleSpeechifyPlayer) return;
    const removeEventListener = articleSpeechifyPlayer.addEventListener(event => {
      event.type === "play" && setIsPlayed(true);
    });
    return () => removeEventListener();
  }, [articleSpeechifyPlayer]);

  useEffect(() => {
    if (!isClicked || !articleSpeechifyPlayer) return;
    articleSpeechifyPlayer.play();
  }, [isClicked, articleSpeechifyPlayer]);

  return (
    <Container className={className}>
      <PippaImage alt={Pippa.alt} src={Pippa.src} />
      <TextContainer>
        <Title>Listen Now</Title>
        <StyledLineImg />
        <Description>Enjoy the audio version of this article!</Description>
      </TextContainer>
      <StyledButton
        $isDisabled={isPlayed}
        backgroundColor={isPlayed ? "#cccccc" : "#fecc17"}
        variant="button"
        onClick={() => {
          if (isClicked || isPlayed) return;
          setIsClicked(true);
        }}
      >
        <StyledPlayIcon />
        Play
      </StyledButton>
      {children?.(isClicked)}
    </Container>
  );
};

ListenNow.displayName = "ListenNow";
